import { createClient } from '@supabase/supabase-js'

// ✅ FIX: 하드코딩 제거, CRA 환경변수(REACT_APP_ 접두사 필수)로 로드
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('❌ .env 파일에 REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY가 없습니다. .env.example을 참고해서 프로젝트 루트에 .env를 만들어주세요.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
